import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, Eye, EyeOff, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const LOGO = "https://customer-assets.emergentagent.com/job_3024c52e-4cee-4083-aea4-e49427d8ac34/artifacts/9fg9a2xl_13921DDF-6D23-4936-90D9-EEE3C5FB5A93.png";

export default function AdminLogin() {
  const nav = useNavigate();
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [show, setShow] = useState(false);
  const [load, setLoad] = useState(false);
  const [err, setErr] = useState('');

  const login = async (e) => {
    e.preventDefault();
    setLoad(true);
    setErr('');
    try {
      const cred = btoa(user + ':' + pass);
      await axios.get(BACKEND_URL + '/api/admin/verify', { headers: { Authorization: 'Basic ' + cred } });
      sessionStorage.setItem('adminAuth', cred);
      nav('/admin');
    } catch (e) {
      setErr(e.response?.status === 401 ? 'Invalid credentials' : 'Connection error');
    }
    setLoad(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <div className="text-center mb-8">
          <img src={LOGO} alt="Logo" className="h-20 mx-auto mb-4" />
          <h1 className="text-2xl font-bold">Admin Login</h1>
          <p className="text-gray-500 text-sm mt-1">Sign in to manage CRM</p>
        </div>
        {err && <div className="bg-red-50 text-red-600 px-4 py-3 rounded-lg mb-6 text-sm">{err}</div>}
        <form onSubmit={login} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Username</label>
            <div className="relative">
              <User size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <Input type="text" value={user} onChange={e => setUser(e.target.value)} placeholder="Enter username" className="pl-10" required />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
            <div className="relative">
              <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <Input type={show ? 'text' : 'password'} value={pass} onChange={e => setPass(e.target.value)} placeholder="Enter password" className="pl-10 pr-10" required />
              <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">{show ? <EyeOff size={18} /> : <Eye size={18} />}</button>
            </div>
          </div>
          <Button type="submit" className="w-full btn-primary" disabled={load}>{load ? <><Loader2 size={18} className="animate-spin" />Signing in...</> : 'Sign In'}</Button>
        </form>
        <div className="mt-6 text-center"><a href="/" className="text-sm text-blue-600 hover:underline">← Back to website</a></div>
      </div>
    </div>
  );
}
